export default __webpack_public_path__ + "static/media/Tokens of the Great Impi.43496bf4.jpg";